import { useState } from 'react';

const useCheckboxListToggle = (defaultState = []) => {
  const [selectedCheckbox, setSelectedCheckbox] = useState(
    new Set(defaultState)
  );
  const toggleCheckbox = checkboxId => {
    const updatedSelectedCheckbox = new Set(selectedCheckbox);
    if (updatedSelectedCheckbox.has(checkboxId)) {
      updatedSelectedCheckbox.delete(checkboxId);
    } else {
      updatedSelectedCheckbox.add(checkboxId);
    }
    setSelectedCheckbox(updatedSelectedCheckbox);
  };

  return [selectedCheckbox, toggleCheckbox];
};

export default useCheckboxListToggle;
